<template>
    <div class="col-12">
        <confirm-box ref="error" :noConfirm="true"></confirm-box>
        <h5 v-if="id" class="h5 text-primary">Editing District</h5>
        <h5 v-else class="h5 text-primary">Create District</h5>
        <div class="row">
            <div class="col-12 col-md-6 mb-2">
                <input type="text" class="form-control" placeholder="District Name" aria-label="District Name" aria-describedby="basic-addon2" v-model="name"/>
            </div>
            
            <div class="col-12 col-md-6 mb-2">
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon1">@</span>
                    <input type="text" class="form-control" placeholder="Email Domain" aria-label="EmailDomain" aria-describedby="basic-addon1" v-model="domain"/>
                </div>
            </div>
        </div>
        <div class="row ">
            <div class="col-12 col-md-6 mb-2">
                <input type="text" class="form-control col-md-6" placeholder="District Address" aria-label="District Address" aria-describedby="basic-addon2" v-model="address"/>
            </div>

            <div class="col-12 col-md-6 mb-2">
                <input type="text" class="form-control col-md-6" placeholder="District Phone" aria-label="District Phone" aria-describedby="basic-addon2" v-model="phone"/>
            </div>
        </div>

        <cancel-submit-button
            @cancel="cancel()"
            @submit="submit()"
        ></cancel-submit-button>
    </div>
</template>

<script>
import ConfirmBox from './ConfirmBox.vue';
import CancelSubmitButton from './CancelSubmitButton.vue';

export default {
    components: { ConfirmBox, CancelSubmitButton },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {};
            },
        }
    },

    data() {
        return {
            name: this.value.name ?? '',
            domain: this.value.domain ?? '',
            address: this.value.address ?? '',
            phone: this.value.phone ?? '',
            id: this.value.id ?? null,
        }
    },

    methods: {
        cancel() {
            this.$emit('cancel', this.id);
        },

        submit() {
            this.$parent.isLoading = true;
            const data = {
                name: this.name,
                domain: this.domain,
                address: this.address,
                phone: this.phone,
                id: this.id,
            };

            if (this.id === null) {
                axios
                    .post('/api/admin/districts', data)
                    .then(response => {
                        console.log(response.data);
                        this.$emit('input', response.data);
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$refs.error.show({
                                title: 'District Update Error',
                                content: error.response.data.message,
                                callback: () => {},
                            });
                        } else {
                            console.error(error);
                        }
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            } else {
                axios
                    .patch(`/api/admin/districts/${this.id}`, data)
                    .then(response => {
                        console.log(response.data);
                        this.$emit('input', response.data);
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$refs.error.show({
                                title: 'District Create Error',
                                content: error.response.data.message,
                                callback: () => {},
                            });
                        } else {
                            console.error(error);
                        }

                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            }
        },

        clear: function() {
            if (!this.id) {
                this.name = '';
                this.domain = '';
                this.address = '';
                this.phone = '';
            }
        }
    }
}

</script>